// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2ZLy1","subheader":"ReorderModal_subheader__3xZA5","listWrap":"ReorderModal_listWrap__1CKSz"};